import { useRef as A, useEffect as N } from "react";
import { useControlledState as T, useTagName as P, useEvent as l, useWrapElement as D, useForkRef as O } from "../../../ariakit-react-utils/esm/hooks.js";
import { createComponent as R, createElement as S, createHook as j } from "../../../ariakit-react-utils/esm/system.js";
import { useCommand as v } from "../command/command.js";
import { C as F } from "../__utils-9dae8b32.js";
import { jsx as H } from "react/jsx-runtime";
function M(r, n) {
  if (r !== void 0)
    return n ? Array.isArray(r) ? r.includes(n) : r === n : Array.isArray(r) ? !1 : typeof r == "boolean" ? r : !1;
}
function p(r, n) {
  n ? r.indeterminate = !0 : r.indeterminate && (r.indeterminate = !1);
}
function W(r, n) {
  return r === "input" && (!n || n === "checkbox");
}
const _ = j((r) => {
  let {
    state: n,
    value: c,
    checked: C,
    defaultChecked: x,
    ...t
  } = r;
  const [i, b] = T(x ?? !1, C ?? M(n == null ? void 0 : n.value, c)), d = A(null), g = P(d, t.as || "input"), o = W(g, t.type), u = i ? i === "mixed" : void 0, f = i === "mixed" ? !1 : i;
  N(() => {
    const e = d.current;
    e && (p(e, u), e.checked = f);
  }, [u, f]);
  const s = t.onChange, m = l((e) => {
    if (t.disabled) {
      e.stopPropagation(), e.preventDefault();
      return;
    }
    if (p(e.currentTarget, u), o || (e.currentTarget.checked = !e.currentTarget.checked), s == null || s(e), e.defaultPrevented) return;
    const k = e.currentTarget.checked;
    b(k), n == null || n.setValue((h) => c ? Array.isArray(h) ? k ? [...h, c] : h.filter((E) => E !== c) : c : k);
  }), a = t.onClick, y = l((e) => {
    a == null || a(e), !e.defaultPrevented && (o || m(e));
  });
  return t = D(t, (e) => /* @__PURE__ */ H(F.Provider, {
    value: f,
    children: e
  }), [f]), t = {
    role: o ? void 0 : "checkbox",
    type: o ? "checkbox" : void 0,
    "aria-checked": i,
    ...t,
    ref: O(d, t.ref),
    onChange: m,
    onClick: y
  }, t = v({
    clickOnEnter: !o,
    ...t
  }), {
    value: o ? c : void 0,
    checked: f,
    ...t
  };
}), q = R((r) => {
  const n = _(r);
  return S("input", n);
});
process.env.NODE_ENV !== "production" && (q.displayName = "Checkbox");
export {
  q as Checkbox,
  _ as useCheckbox
};
//# sourceMappingURL=checkbox.js.map
